import type { AssetId } from '@/shared/types/core'

/**
 * 生成唯一资产 ID，优先使用 crypto.randomUUID()，降级使用伪 UUID v4。
 *
 * @returns 形如 UUID v4 的字符串
 */
export function generateId(): AssetId {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID()
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0
    const v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}
